module.exports = __webpack_public_path__ + "img/poseAiguilleCCI.cf9141c6.jpg";